import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { createReduxStore } from '../../../shared/utils/redux';
import { IApplicationState } from '../../../shared/types/redux';

export function createApplicationState() {
  const config = getConfig();
  const httpApi = getHttpApi();
  const logger = getLogger();

  const initialState = config.getStrict<IApplicationState>('initialState');

  const reduxContext = {
    config,
    httpApi,
    logger,
  };

  return createReduxStore({ initialState, context: reduxContext, debugEnabled: true });
}
